export enum BillingsCargoTaxiContributionDiscountType {
  DISCOUNT_OPTIMIZATION = "DISCOUNT_OPTIMIZATION",
  DISCOUNT_BEING_LATE = "DISCOUNT_BEING_LATE",
  DISCOUNT_INCOMPATIBLE_CAR = "DISCOUNT_INCOMPATIBLE_CAR",
  DISCOUNT_OTHER = "DISCOUNT_OTHER",
  CONTRACT_CORRECTION_PERCENTAGE = "CONTRACT_CORRECTION_PERCENTAGE",
}

export type BillingsCargoTaxiContributionDummy = {
  type: null;
  comment: string;
  percentage: number | null;
  amount: number | null;
};

export type BillingsCargoTaxiContributionContractCorrectionPercentage = {
  type: BillingsCargoTaxiContributionDiscountType.CONTRACT_CORRECTION_PERCENTAGE;
  percentage: number | null;
  amount: number | null;
};

export type BillingsCargoTaxiContributionDiscountOptimization = {
  type: BillingsCargoTaxiContributionDiscountType.DISCOUNT_OPTIMIZATION;
  comment: string;
  amount: number | null;
};

export type BillingsCargoTaxiContributionDiscountBeingLate = {
  type: BillingsCargoTaxiContributionDiscountType.DISCOUNT_BEING_LATE;
  comment: string;
  amount: number | null;
};

export type BillingsCargoTaxiContributionDiscountIncompatibleCar = {
  type: BillingsCargoTaxiContributionDiscountType.DISCOUNT_INCOMPATIBLE_CAR;
  comment: string;
  amount: number | null;
};

export type BillingsCargoTaxiContributionDiscountOther = {
  type: BillingsCargoTaxiContributionDiscountType.DISCOUNT_OTHER;
  comment: string;
  amount: number | null;
};

export type BillingsCargoTaxiContributionReal =
  | BillingsCargoTaxiContributionContractCorrectionPercentage
  | BillingsCargoTaxiContributionDiscountOptimization
  | BillingsCargoTaxiContributionDiscountBeingLate
  | BillingsCargoTaxiContributionDiscountIncompatibleCar
  | BillingsCargoTaxiContributionDiscountOther;

type BillingsCargoTaxiContributionDiscount =
  | BillingsCargoTaxiContributionReal
  | BillingsCargoTaxiContributionDummy;

export default BillingsCargoTaxiContributionDiscount;
